import Vue from "vue";
import Vuex from "vuex";

import lectorsModule from "./modules/lectors";
import partnersModule from "./modules/partners";
import commentsModule from "./modules/comments";
import teamModule from "./modules/team";
import registrationModule from "./modules/registration";
import axios from "axios";

Vue.use(Vuex);

const host = "https://lsaran.online/api";

export default new Vuex.Store({
  modules: {
    lectorsModule,
    partnersModule,
    commentsModule,
    teamModule,
    registrationModule
  },
  mutations: {},
  actions: {
    async loadMainInfo({ state }) {
      const response = await axios(state.endpoints.mainInfo);
      if (response.status === 200) {
        state.dates = response.data.data.dates;
        state.contacts = response.data.data.contacts;
      }
    }
  },
  state: {
    host: host,
    pageScroll: 0,
    scrollBottomPage: false,
    contacts: {},
    dates: {},
    endpoints: {
      mainInfo: host + "/main-info",
      schedule: host + "/schedule",
      lectors: host + "/lecturers",
      partners: host + "/partners"
    },
    menuItems: [
      {
        title: "Лсаран 2022",
        url: "/",
        child: [
          {
            title: "Принципы",
            url: "/principes",
            child: []
          },
          {
            title: "Лекторы",
            url: "/lectors",
            child: []
          },
          // {
          //   title: "Расписание",
          //   url: "/program",
          //   child: []
          // },
          {
            title: "Регистрация",
            url: "/register",
            child: []
          }
          // {
          //   title: "Вечерняя программа",
          //   url: "/evening-program",
          //   child: []
          // },
          // {
          //   title: "Детская программа",
          //   url: "/children-program",
          //   child: []
          // }
        ]
      },
      {
        title: "Наши друзья",
        url: "/friends",
        child: []
      },
      {
        title: "Команда",
        url: "/team",
        child: []
      },
      {
        title: "Стоимость",
        url: "/price",
        child: []
      }
      // {
      //   title: "Как проехать",
      //   url: "/contacts",
      //   child: []
      // },
      // {
      //   title: "История",
      //   url: "/archive",
      //   child: []
      // }
      // {
      //   title: "Поддержка Лсаран",
      //   url: "/help",
      //   child: []
      // }
    ],
    drawer: false
  },
  getters: {
    getHost(state) {
      return state.host;
    },
    getEndpoints(state) {
      return state.endpoints;
    },
    getMenuItems(state) {
      return state.menuItems;
    },
    getContacts(state) {
      return state.contacts;
    },
    getDates(state) {
      return state.dates;
    }
  }
});
